import React, { useEffect } from "react";
import PropTypes from "prop-types";

// hooks
import { useIosInputFocusLightBox } from "./useIosInputFocusLightBox";
import { useDisableBodyScroll } from "frontend/hooks/useDisableBodyScroll.js";

// components
import LightBox from "./components/LightBox";

// component
const MountingWrapper = ({ children }) => {
    const { isOpen } = useIosInputFocusLightBox();

    const { disableBodyScroll } = useDisableBodyScroll({
        disableIosTouchMove: true
    });

    useEffect(() => {
        disableBodyScroll(isOpen);
    }, [isOpen]);

    return <LightBox>{children}</LightBox>;
};

export default MountingWrapper;

// prop-types
MountingWrapper.propTypes = {
    children: PropTypes.any
};
